module.exports = __webpack_public_path__ + "static/media/22.b85c7750.jpg";